import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { OrganizationsPage } from '@features/admin/organizations';
import { useAdminOrganizationStore } from '@features/admin/organizations/useAdminOrganizationStore.ts';

const organizationTypeSchema = z.enum(['SUPPLIER', 'CLIENT']).optional();

const adminOrganizationsSearchSchema = z.object({
  q: z.string().optional(),
  type: organizationTypeSchema,
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminOrganizationsSearch = z.infer<typeof adminOrganizationsSearchSchema>;
export type OrganizationType = z.infer<typeof organizationTypeSchema>;

export const Route = createFileRoute('/admin/organizations/')({
  validateSearch: search => adminOrganizationsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, type, page, size } = ctx.search;
    useAdminOrganizationStore.getState().loadOrganizations({
      q,
      type,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <OrganizationsPage />;
}
